var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 2.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M5.25 6a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.25 12.25h15.5V18h-1.5v-4.25H3.75V18h-1.5z",
    clipRule: "evenodd",
    opacity: 0.5
  })));
};
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAyLjc1QzguMjA1MDcgMi43NSA2Ljc1IDQuMjA1MDcgNi43NSA2QzYuNzUgNy43OTQ5MyA4LjIwNTA3IDkuMjUgMTAgOS4yNUMxMS43OTQ5IDkuMjUgMTMuMjUgNy43OTQ5MyAxMy4yNSA2QzEzLjI1IDQuMjA1MDcgMTEuNzk0OSAyLjc1IDEwIDIuNzVaTTUuMjUgNkM1LjI1IDMuMzc2NjUgNy4zNzY2NSAxLjI1IDEwIDEuMjVDMTIuNjIzNCAxLjI1IDE0Ljc1IDMuMzc2NjUgMTQuNzUgNkMxNC43NSA4LjYyMzM1IDEyLjYyMzQgMTAuNzUgMTAgMTAuNzVDNy4zNzY2NSAxMC43NSA1LjI1IDguNjIzMzUgNS4yNSA2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggb3BhY2l0eT0iMC41IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuMjUgMTIuMjVIMTcuNzVWMThIMTYuMjVWMTMuNzVIMy43NVYxOEgyLjI1VjEyLjI1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";